// extracted by mini-css-extract-plugin
export default {"main":"styles_main__s1zs9","presets-list":"styles_presets-list__xgWzX"};